import * as React from "react";
import { CaseStatus } from "@kahunmedical/common-wtypes";
import { styled, Tooltip } from "@mui/material";
import { ReactComponent as InProgressIcon } from "../assets/inProgressIcon.svg";
import { ReactComponent as SuccessIcon } from "../assets/successIcon.svg";
import InfoIcon from "@mui/icons-material/Info";

//region [[ Styles ]]

const PatientStatusView = styled("span")({
  display: "flex",
  alignItems: "center",
  gap: 4,
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PatientStatusProps {
  status: CaseStatus;
  updated: string;
}

const patientStatusNames = {
  [CaseStatus.CREATED]: { text: "Created", icon: <InProgressIcon /> },
  [CaseStatus.IN_PROGRESS]: {
    text: "In Progress",
    icon: <InProgressIcon />,
  },
  [CaseStatus.PROVISIONAL_ABANDONED]: {
    text: "In Progress",
    icon: <InProgressIcon />,
  },
  [CaseStatus.PROVISIONAL_COMPLETED]: {
    text: "In Progress",
    icon: <InProgressIcon />,
  },
  [CaseStatus.COMPLETED]: {
    text: "Completed",
    icon: <SuccessIcon />,
  },
  [CaseStatus.ABANDONED]: {
    text: "Abandoned",
    icon: <InfoIcon color="secondary" />,
  },
};

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PatientStatus = ({ ...props }: PatientStatusProps) => {
  return (
    <Tooltip
      title={patientStatusNames[props.status]?.text + " on " + props.updated}
    >
      <PatientStatusView className="patientStatus">
        {patientStatusNames[props.status]?.icon}
        {patientStatusNames[props.status]?.text}
      </PatientStatusView>
    </Tooltip>
  );
};
